import _merge from 'lodash/merge'
import { getQs } from '../queryString'

const CONSUMERS_CFG = {
  'b2b-agency': {
    base: () => import('config/consumers/b2b-agency/cfg.base.json'),
    production: () => import('config/consumers/b2b-agency/cfg.prod.json')
  }
}

const getDef = module => module.default

export const getConsumerConfig = async () => {
  const appId = getQs('appId')
  const cfg = CONSUMERS_CFG[appId]
  if (!cfg) return Promise.resolve({})

  const { base } = cfg
  const env = cfg.production
  
  if(process.env.NODE_ENV !== 'development') {
    const [baseCfg, envCfg] = await Promise.all([base(), env()])
    return _merge(getDef(baseCfg), getDef(envCfg))
  } else return getDef(await base())
}
